import React from 'react'
import { Box } from 'theme-ui'
import { FaArchive } from 'react-icons/fa'
import IconButton from '@components/IconButton'
import Section from '@components/Section'

const styles = {
  horizontal: {
    display: `flex`,
    flexWrap: `wrap`,
    overflowX: `auto`,
    width: `auto`,
    scrollBehavior: `smooth`,
    a: {
      flex: 1,
      minWidth: [`1/1`, `auto`],
      m: 2
    },
  }
}

const Categories = ({categories, ...props }) => (
  <Section {...props}>
    <Box>
      {categories &&
        categories.map(({ id, name, slug, totalCount, icon }) => {
          const buttonProps = {
            key: id,
            name,
            number: totalCount,
            to: slug,
          }

          return totalCount !== 0 && <IconButton {...buttonProps} />
        })}
    </Box>
  </Section>
)

export default Categories

Categories.defaultProps = {
  variant: 'vertical'
}
